import { __ } from '@wordpress/i18n'

import { countries } from '../shared/countries'

export default {
  labels: {
    strFirma: __('Name Ihres Unternehmens', 'dhsv_theme'),
    strAnrede: __('Anrede', 'dhsv_theme'),
    strVorname: __('Vorname', 'dhsv_theme'),
    strNachname: __('Name', 'dhsv_theme'),
    strPosition: __('Position', 'dhsv_theme'),
    strZustaendigFuer: __('Zuständig für', 'dhsv_theme'),
    strStrasse: __('Straße & Hausnummer', 'dhsv_theme'),
    strPLZ: __('PLZ', 'dhsv_theme'),
    strOrt: __('Ort', 'dhsv_theme'),
    strLand: __('Ihr Standort liegt in', 'dhsv_theme'),
    strEmail: __('Ihre geschäftliche E-Mail', 'dhsv_theme'),
    strTelefon: __('Ihre geschäftliche Telefonnummer', 'dhsv_theme'),
    strKundenNr: __('Ihre Kundennummer', 'dhsv_theme'),
    memKommentar: __('Ihre Nachricht an uns', 'dhsv_theme'),
    addParticipant: __('Teilnehmer hinzufügen', 'dhsv_theme'),
    labelParticipant: __('Teilnehmer', 'dhsv_theme'),
    ysnPrivacy: __(
      'Ja, ich habe die <a target="_blank" href="/datenschutz">Datenschutzerklärung</a> gelesen.',
      'dhsv_theme'
    ),
    ysnPrivacyFirst: __('Ja, ich habe die ', 'dhsv_theme'),
    ysnPrivacySecond: __(' gelesen.', 'dhsv_theme'),
    ysnPrivacyInfoCH: __(
      'Wir informieren Sie hiermit darüber, dass wir Ihre Teilnahme-Daten an den Hersteller weiterleiten werden.',
      'dhsv_theme'
    ),
    ysnPrivacyMessageCH: __(
      'Ich bin damit einverstanden, dass meine Daten an den in der Veranstaltung genannten Hersteller weitergeleitet werden.',
      'dhsv_theme'
    ),
    ysnPrivacyInfoDE: __(
      'Wir informieren Sie hiermit darüber, dass wir Ihre Teilnahme-Daten an den Hersteller weiterleiten werden. Dies geschieht im berechtigten Interesse daran, zu Marketing-Zwecken mit Ihnen in Verbindung zu treten (Art. 6 Abs. 1 lit. f in Verb. mit EG 47 DSGVO).',
      'dhsv_theme'
    ),
    submit: __('Jetzt anmelden', 'dhsv_theme'),
    registerNow: __('Jetzt anmelden', 'dhsv_theme'),
    registerNowCost: __('Jetzt kostenpflichtig anmelden', 'dhsv_theme'),
    training: __('Schulung', 'dhsv_theme'),
    trainingRegistration: __('Anmeldung zur Schulung', 'dhsv_theme'),
    priceStr: __('Preis', 'dhsv_theme'),
    appointmentStr: __('Termin', 'dhsv_theme'),
  },
  selectOptions: {
    strAnrede: {
      mr: __('Herr', 'dhsv_theme'),
      ms: __('Frau', 'dhsv_theme'),
      mx: __('Divers', 'dhsv_theme'),
    },
    strLand: countries,
  },
  successMessage: __('Formular erfolgreich gesendet', 'dhsv_theme'),
  validationMessages: {
    email: __('Bitte geben Sie eine gültige E-Mail-Adresse an', 'dhsv_theme'),
    limitExceeded: __('Bitte geben sie maximal %d Zeichen ein', 'dhsv_theme'),
    required: __('Bitte füllen Sie das Feld aus', 'dhsv_theme'),
    ysnPrivacy: __(
      'Bitte stimmen Sie der Übermittlung Ihrer Daten zu',
      'dhsv_theme'
    ),
  },
}
